import Icon from '../components/Icon.vue'

Icon.register({
  'sign-out-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497 273l-168 168c-15 15-41 4.5-41-17v-96h-136c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136v-96c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436c0 6.6-5.4 12-12 12h-84c-53 0-96-43-96-96v-192c0-53 43-96 96-96h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-84c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h84c6.6 0 12 5.4 12 12v40z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sign-out-alt.js
// module id = 1889
// module chunks = 0